import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ExternalList, FormListItem } from '../models/form';

export class ExternalLists {

    constructor(public http: HttpClient,public externalId: number) {
    }

    public getList(listCode: string, dispCode: string): Array<FormListItem> {
        let ll = listCode.split(';');
        let ld = dispCode.split(';');
        let ary = new Array<FormListItem>();

        if(ll[1] == 'worquest_state') {
            this.getWQList(ary, 'state', ll[2], ld[2])
        } else if(ll[1] == 'worquest_department') {
            this.getWQList(ary, 'department', ll[2], ld[2])
        } else if(ll[1] == 'worquest_location') {
            this.getWQList(ary, 'location', ll[2], ld[2])
        }


        return ary;
    }

    public getWQList(ary: Array<FormListItem>, dataType: string, listCol: string, dispCol: string) {
        //console.log('ext list for ' + dataType + ' ' + listCol + ' ' + dispCol);
        let url = `${environment.apiUrl}/ThirdParty/List/` + dataType + '/' + this.externalId + '/' + dispCol;
        this.http.get(url).toPromise().then(res => {
            let el = res as ExternalList[];
            
            for(let a = 0; a < el.length; a++) {
                //console.log(a + ' ' + el[a].ListId + ' ' + el[a].ListCode + ' ' + el[a].ListName);
                let l1 = "" + el[a].ListId;
                let l2 = "" + el[a].ListId;

                if(listCol == 'code') l1 = el[a].ListCode;
                if(dispCol == 'code') l2 = el[a].ListCode;

                if(listCol == 'name') l1 = el[a].ListName;
                if(dispCol == 'name') l2 = el[a].ListName;

                let itm = new FormListItem(l1, l2);
                ary.push(itm);
            }
        });
    }

    public static mimeType(typ: string): string {
        let rtn = '';
  
        if(typ == 'doc') rtn = 'application/msword';
        if(typ == 'docx') rtn = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        if(typ == 'json') rtn = 'application/json';
        if(typ == 'pdf') rtn = 'application/pdf';
        if(typ == 'ppt') rtn = 'application/vnd.ms-powerpoint';
        if(typ == 'pptx') rtn = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
        if(typ == 'rtf') rtn = 'application/rtf';
        if(typ == 'txt') rtn = 'text/plain';
        if(typ == 'xls') rtn = 'application/vnd.ms-excel';
        if(typ == 'xlsx') rtn = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  
        if(typ == 'bmp') rtn = 'image/bmp';
        if(typ == 'gif') rtn = 'image/gif';
        if(typ == 'jpg') rtn = 'image/jpg';
        if(typ == 'jpeg') rtn = 'image/jpeg';
        if(typ == 'png') rtn = 'image/png';
        if(typ == 'tif') rtn = 'image/tif';
        if(typ == 'tiff') rtn = 'image/tiff';
  
        if(typ == 'msg') rtn = 'application/vnd.ms-outlook';
        
        if(typ == 'html') rtn = 'text/html';
        if(typ == 'xml') rtn = 'text/xml';
  
        return rtn;
      }
    }
